export default __webpack_public_path__ + "static/media/Deceiver's Boots of Whispered Deeds.3a9c06a2.jpg";